var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2876_43731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8999 11C2.48569 11 2.1499 11.3358 2.1499 11.75C2.1499 12.1642 2.48569 12.5 2.8999 12.5C3.31412 12.5 3.6499 12.1642 3.6499 11.75C3.6499 11.3358 3.31412 11 2.8999 11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14979 12.5L21.0298 12.5L21.0298 11L5.14979 11L5.14979 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3801 3.5L21.5601 10.69C21.7004 10.8286 21.8117 10.9936 21.8878 11.1756C21.9638 11.3576 22.0029 11.5528 22.0029 11.75C22.0029 11.9472 21.9638 12.1424 21.8878 12.3244C21.8117 12.5064 21.7004 12.6714 21.5601 12.81L14.3801 20L13.3101 18.93L20.5001 11.74L13.3101 4.55L14.3801 3.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2876_43731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.85,
    height: 16.49,
    fill: "white",
    transform: "translate(22 20) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.6310c978.svg";
export { ForwardRef as ReactComponent };